"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BSKY_LABELER_DID = void 0;
exports.BSKY_LABELER_DID = 'did:plc:ar7c4by46qjdydhdevvrndac';
//# sourceMappingURL=const.js.map